"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FatIssues = exports.MainGoals = exports.ActivityTypes = exports.SleepHours = exports.DaysInWeek = exports.WorkHours = exports.VerificationType = exports.BloodTypeInput = exports.TrainerStatus = exports.Role = exports.ConfigTypes = exports.LanguageDetectorApi = exports.TraineeTrainerPackageStatus = exports.SortMode = exports.LanguageIds = exports.MockObjectID = exports.CdnHeaderKey = exports.RefreshTokenCookieKey = exports.RefreshTokenHeaderKey = exports.TokenCookieKey = exports.TokenHeaderKey = exports.UserCreditHeaderKey = exports.AdminTrainerId = void 0;
exports.AdminTrainerId = "59bd1cd9eab23d03ac08b88b";
exports.UserCreditHeaderKey = "x-rb-newusercredit";
exports.TokenHeaderKey = "x-access-token";
exports.TokenCookieKey = "access_token";
exports.RefreshTokenHeaderKey = "x-refresh-token";
exports.RefreshTokenCookieKey = "refresh_token";
exports.CdnHeaderKey = "x-select-cdn";
exports.MockObjectID = "000000000000000000000000";
var LanguageIds;
(function (LanguageIds) {
    LanguageIds["fa"] = "594a3fc1e8ee747f44832183";
    LanguageIds["en"] = "594a3f9ce8ee747f44832170";
    LanguageIds["ar"] = "594a3f9ce8ee747f44832172";
    LanguageIds["tr"] = "594a3f9ce8ee747f44832171";
    LanguageIds["es"] = "594a3f9ce8ee747f44832173";
    LanguageIds["fr"] = "594a3f9ce8ee747f44832174";
    LanguageIds["pt"] = "594a3f9ce8ee747f44832175";
    LanguageIds["da"] = "594a3f9ce8ee747f44832176";
    LanguageIds["vi"] = "594a3f9ce8ee747f44832177";
})(LanguageIds = exports.LanguageIds || (exports.LanguageIds = {}));
var SortMode;
(function (SortMode) {
    SortMode["ASC"] = "ASC";
    SortMode["DESC"] = "DESC";
})(SortMode = exports.SortMode || (exports.SortMode = {}));
/**
 * status of a trainer with a trainee
 * priority is for when there are two status at the same time
 */
var TraineeTrainerPackageStatus;
(function (TraineeTrainerPackageStatus) {
    // trainee has not bought any package from the trainer (priority 5)
    TraineeTrainerPackageStatus["NO_PACKAGE"] = "NO_PACKAGE";
    // trainee has only expired packages from the trainer (priority 4)
    TraineeTrainerPackageStatus["INACTIVE"] = "INACTIVE";
    // trainee has package with the trainer and has not expired yet (priority 3)
    TraineeTrainerPackageStatus["ACTIVE"] = "ACTIVE";
    // trainee package request was approved but has not been sent yet (priority 2)
    TraineeTrainerPackageStatus["PACKAGE_PENDING"] = "PACKAGE_PENDING";
    // trainee has requested a package and waiting from trainer approval (priority 1)
    TraineeTrainerPackageStatus["REQUEST_PENDING"] = "REQUEST_PENDING";
})(TraineeTrainerPackageStatus = exports.TraineeTrainerPackageStatus || (exports.TraineeTrainerPackageStatus = {}));
exports.LanguageDetectorApi = {
    ApiPath: "https://ipapi.co/json/",
    CountryCodeField: "country_code",
    IpAddressField: "ip",
};
var ConfigTypes;
(function (ConfigTypes) {
    ConfigTypes["Base"] = "Base";
    ConfigTypes["IpLog"] = "IpLog";
})(ConfigTypes = exports.ConfigTypes || (exports.ConfigTypes = {}));
var Role;
(function (Role) {
    Role["Admin"] = "Admin";
    Role["Trainer"] = "Trainer";
    Role["Trainee"] = "Trainee";
})(Role = exports.Role || (exports.Role = {}));
var TrainerStatus;
(function (TrainerStatus) {
    TrainerStatus["InProgress"] = "In Progress";
    TrainerStatus["Confirmed"] = "Confirmed";
})(TrainerStatus = exports.TrainerStatus || (exports.TrainerStatus = {}));
var BloodTypeInput;
(function (BloodTypeInput) {
    BloodTypeInput["AB_Neg"] = "AB-";
    BloodTypeInput["AB_Pos"] = "AB+";
    BloodTypeInput["A_Neg"] = "A-";
    BloodTypeInput["A_Pos"] = "A+";
    BloodTypeInput["B_Neg"] = "B-";
    BloodTypeInput["B_Pos"] = "B+";
    BloodTypeInput["O_Neg"] = "O-";
    BloodTypeInput["O_Pos"] = "O+";
})(BloodTypeInput = exports.BloodTypeInput || (exports.BloodTypeInput = {}));
var VerificationType;
(function (VerificationType) {
    VerificationType["MOBILE"] = "MOBILE";
    VerificationType["EMAIL"] = "EMAIL";
})(VerificationType = exports.VerificationType || (exports.VerificationType = {}));
exports.WorkHours = [20, 40, 60, 80, 100, 120, 140];
exports.DaysInWeek = [1, 2, 3, 4, 5, 6, 7];
exports.SleepHours = [4, 6, 8, 10, 12, 14, 16];
exports.ActivityTypes = ["quite_active", "low_active", "high_active"];
exports.MainGoals = [
    "bulk_up",
    "lose_weight_and_shape",
    "strength_and_definition",
    "physiotherapy_and_rehabilitation",
    "energy_and_health",
    "weight_gain",
    "increased_endurance",
    "increased_cardiovascular_endurance",
    "increased_agility",
    "increased_balance_and_focus",
    "increase_speed",
    "maintaining_good_health_and_fitness",
    "increased_vo2max_capacity",
];
exports.FatIssues = [
    "belly",
    "side",
    "arm",
    "leg",
    "waist",
    "hip",
    "chest",
];
//# sourceMappingURL=constants.js.map